module.exports = {
          srcSet: __webpack_public_path__ + "public/images/988c651c8766d582be55d7aa43f26710-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/988c651c8766d582be55d7aa43f26710-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/988c651c8766d582be55d7aa43f26710-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/988c651c8766d582be55d7aa43f26710-1774.jpg"},
          
          width: 1774,
          height: 887
        }